"use client";

import { cn } from "@/lib/utils";
import { useLayoutEffect, useRef, useState } from "react";

interface PageChipLabelProps {
  label: string;
}

/**
 * Chip label that fades out on the right when the stretched chip is too narrow for the text.
 */
export function PageChipLabel({ label }: PageChipLabelProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const [isClipped, setIsClipped] = useState(false);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;

    const updateClipped = () => {
      setIsClipped(element.scrollWidth > element.clientWidth + 1);
    };

    updateClipped();

    const observer = new ResizeObserver(updateClipped);
    observer.observe(element);
    return () => observer.disconnect();
  }, [label]);

  return (
    <span
      ref={ref}
      className={cn(
        "block w-full min-w-0 max-w-full overflow-hidden whitespace-nowrap text-center",
        isClipped &&
          "[mask-image:linear-gradient(to_right,black_calc(100%-1.25rem),transparent)] [-webkit-mask-image:linear-gradient(to_right,black_calc(100%-1.25rem),transparent)]"
      )}
    >
      {label}
    </span>
  );
}
